function checkFormValidation(form) {
  form.$setSubmitted();
  return form.$valid;
}

export default {
  checkFormValidation,
};



// WEBPACK FOOTER //
// ./src/modules/utils/multilanguage/helpers/multilanguage-helpers.js